import type { ReactNode } from "react";

export type typeDayDividerProps = {
  label: string;
};

export const DayDivider = (props: typeDayDividerProps): ReactNode => {
  return (
    <div
      className="flex items-center gap-2 py-2"
      data-testid="conversation-day-divider"
    >
      <span className="h-px flex-1 bg-hairline" />
      <span className="text-caption text-ink-tertiary">{props.label}</span>
      <span className="h-px flex-1 bg-hairline" />
    </div>
  );
};
